let RGB = require('./RGB');

module.exports = class Color {
    constructor() {
        /** @type {String} */   this.hex = null;
        /** @type {RGB} */      this.rgb = null;
    }
}
